import React from 'react';
import { Tabs } from 'antd';
import useQuery from '../../../../../hooks/useQuery';
import { useBooking } from '../../../../../contexts/ticketBookingContext/TicketBookingContext';
import SelectBookingTabItems from './bookingTabItems/SelectBookingTabItems';
import AutoBookingTabItems from './bookingTabItems/AutoBookingTabItems';
import BookBookingTabItems from './bookingTabItems/BookBookingTabItems';
import CompleteStatementBookingTabItems from './bookingTabItems/CompleteStatementBookingTabItems';

const bookingTypeTabItems = {
  select: SelectBookingTabItems,
  auto: AutoBookingTabItems,
  book: BookBookingTabItems,
  completeBooking: CompleteStatementBookingTabItems,
};
function BookingSteps() {
  const query = useQuery();
  const bookingTabItems = (bookingTypeTabItems[query.get('seatFormation')] || (() => ([])))();

  const {
    activeStep,
  } = useBooking();

  return (
    <Tabs className="no-tablist" items={bookingTabItems} activeKey={activeStep} />
  );
}

export default BookingSteps;
